import { TInitialState } from '@r1-frontend/service-engineer-visit/reducer/initialState';

const getSlots = (state: TInitialState) => Object.values(state.slots);

export default getSlots;
